import { useEffect, useState, type FC } from 'react';
import styles from './index.module.scss';
import { usePumpTradePresent } from '@hooks/use-pump-trade';
import { formatAddress } from '@mysten/sui/utils';
import { OpenapiClientPump } from 'foca-openapi';
import { Link } from 'react-router-dom';
import { bigNumberToReadable } from '@utils/big-number-to-readable';

export const NewTrade: FC = () => {
  const present = usePumpTradePresent();
  const [_, setCacheData] = useState<OpenapiClientPump.GetTradePresentResponse>([]);

  const [showData, setShowData] = useState<OpenapiClientPump.GetTradePresentResponse>([]);
  const [removingIds, setRemovingIds] = useState<string[]>([]);

  useEffect(() => {
    if (present.length > 0) {
      setCacheData((pre) => [...pre, ...present]);
    }
  }, [JSON.stringify(present)]);

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;
    const loop = () => {
      let cache: OpenapiClientPump.GetTradePresentResponse[number];
      setCacheData((pre) => {
        if (pre.length < 1) {
          return pre;
        }
        cache = pre[0]!;
        return pre.slice(1);
      });
      setShowData((pre) => {
        if (cache) {
          return [...pre, cache];
        }
        return pre;
      });
      timer = setTimeout(() => {
        loop();
      }, 1000 * 3);
    };
    loop();
    return () => {
      clearTimeout(timer);
    };
  }, []);

  const removeData = (digest: string) => {
    setRemovingIds((pre) => [...pre, digest]);
  };

  if (showData.length < 1) return null;

  return (
    <>
      {showData.map((item, index) => {
        return removingIds.includes(item.tx_digest) ? null : (
          <List data={item} key={index + item.tx_digest} index={index} removeData={removeData} />
        );
      })}
    </>
  );
};

const List: FC<{
  data: OpenapiClientPump.GetTradePresentResponse[number];
  index: number;
  removeData(digest: string): void;
}> = ({ data, index, removeData }) => {
  const [isHover, setIsHover] = useState(false);
  useEffect(() => {
    if (isHover) {
      return;
    }
    let timer: NodeJS.Timeout | undefined;
    timer = setTimeout(() => {
      removeData(data.tx_digest);
    }, 30000);
    return () => {
      clearTimeout(timer);
    };
  }, [data.tx_digest, isHover]);

  return (
    <Link
      to={`/fun/${data.token_address}`}
      className={styles.new_trade}
      style={{ top: index % 2 === 0 ? '160px' : '220px' }}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className={styles.items} key={data.tx_digest}>
        <span>{formatAddress(data.sender)}</span>
        {data.is_buy ? 'Bought' : 'Sold'}
        <span>
          {bigNumberToReadable(data.token_amount, 0, true)} ${data.token_metadata?.symbol || ''}
        </span>
        <img src={data.token_metadata?.iconUrl || ''} />
      </div>
    </Link>
  );
};

export default NewTrade;
